import { render } from "./PaymentFailed.vue?vue&type=template&id=7911a4bc&scoped=true"
const script = {}

import "./PaymentFailed.vue?vue&type=style&index=0&id=7911a4bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7911a4bc"]])

export default __exports__